import React from "react";

export const FlechCercle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none">
      <rect
        x="31.5"
        y="0.5"
        width="31"
        height="31"
        rx="15.5"
        transform="rotate(90 31.5 0.5)"
        fill="#2481A6"
        fill-opacity="0.05"
      />
      <rect
        x="31.5"
        y="0.5"
        width="31"
        height="31"
        rx="15.5"
        transform="rotate(90 31.5 0.5)"
        stroke="#2481A6"
      />
      <path
        d="M16.6154 9L24 16L16.6154 23M22.9744 16H8"
        stroke="#2481A6"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
